import React, { useState } from "react";
import Send from "./send.svg";
import toast from "react-hot-toast";
import emailjs from "@emailjs/browser";
function SendMailer() {
  function clickHandler(e) {
    e.preventDefault();

    toast.success("Message Sent!", {
      style: {
        border: "1px solid #713200",
        padding: "16px",
        color: "#713200",
      },
      iconTheme: {
        primary: "#713200",
        secondary: "#FFFAEE",
      },
    });
    const publicKey = "VHh1qDkPDaGbfgZDK";
    const params = {
      from_name: formData.name,
      to_name: "Shreyash",
      from_email: formData.email,
      message: formData.message,
    };

    setFormData({
      name: "",
      email: "",
      message: "",
    });
    emailjs.send("service_2vv797s", "template_1zlj44m", params, publicKey).then(
      () => {
        console.log("SUCCESS!");
      },
      (error) => {
        console.log("FAILED...", error.text);
      }
    );
  }

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  function handleChange(event) {
    const { name, value } = event.target;
    setFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  }
  return (
    <div className="">
      <form onSubmit={clickHandler}>
        <h2 className="text-center font-medium mb-5 lg:text-xl">
          Write me Your Query
        </h2>

        <div className="space-y-8">
          <div className="relative text-[0.8rem]">
            <label
              className="absolute -top-3 left-4 
                z-20 bg-gray-50 px-2"
              htmlFor="name"
            >
              Name
            </label>
            <input
              className="border bg-gray-50 border-black rounded-xl w-full px-6 py-4"
              type="text"
              id="name"
              name="name"
              required
              onChange={handleChange}
              value={formData.name}
              placeholder="Insert Your Name"
            />
          </div>

          <div className="relative text-[0.8rem] ">
            <label
              className="absolute -top-3 left-4 
                z-20 bg-gray-50 px-2"
              htmlFor="mail"
            >
              Mail
            </label>
            <input
              id="mail"
              required
              onChange={handleChange}
              name="email"
              value={formData.email}
              className="border bg-gray-50 border-black rounded-xl w-full px-6 py-4"
              type="email"
              placeholder="Insert Your Email"
            />
          </div>

          <div className="relative text-[0.8rem] ">
            <label
              className="absolute -top-3 left-4 
                z-20 bg-gray-50 px-2"
              htmlFor="message"
            >
              Message
            </label>
            <textarea
              className="border bg-gray-50 border-black rounded-xl w-full px-6 pt-4
              h-52"
              id="message"
              required
              placeholder="Write Your Message"
              onChange={handleChange}
              name="message"
              value={formData.message}
            ></textarea>
          </div>

          <button
            className="flex transition-all duration-200
               hover:bg-black items-center gap-2 bg-gray-900
                 rounded-xl px-[25px] py-[15px]"
          >
            <span className="text-white">Send Message</span>
            <img className="" src={Send} alt="" />
          </button>
        </div>
      </form>
    </div>
  );
}

export default SendMailer;
